// extracted by mini-css-extract-plugin
export default {"postWrapper":"postMessage_postWrapper__-oT+f"};